<template>
  <button
    data-tour="lens-connect-auth"
    class="authenticate-platform-btn"
    v-on="$listeners"
    :disabled="loading"
    :class="[platform, {'loading cursor-default': loading}]"
  >
    <BaseLoadingSpinnerCircle v-if="loading" :duration="1.2" class="text-white" />
    <MonoMetaIcon v-else-if="platform === 'meta'" class="text-white" />
    <MonoTiktokIcon v-else-if="platform === 'tiktok'" class="text-white" />
    <BaseText type="label" size="sm" class="text-white">
      Authenticate {{ isFirstAccount ? '' : 'New ' }} {{ formattedPlatformName }} Account
    </BaseText>
  </button>
</template>

<script>
import MonoMetaIcon from '../../../globals/Icons/socials/mono/MonoMetaIcon.vue'
import MonoTiktokIcon from '../../../globals/Icons/socials/mono/MonoTiktokIcon.vue'

export default {
  name: 'AuthenticatePlatformButton',
  components: {
    MonoMetaIcon,
    MonoTiktokIcon
  },
  props: {
    platform: {
      type: String,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    isFirstAccount: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    formattedPlatformName () {
      return this.platform === 'meta' ? 'Meta' : 'TikTok'
    }
  }
}
</script>

<style scoped>
@property --grad-left-color {
  syntax: '<color>';
  initial-value: rgba(0, 131, 255, 1);
  inherits: false;
}
@property --grad-right-color {
  syntax: '<color>';
  initial-value: rgba(0, 131, 255, 1);
  inherits: false;
}
.authenticate-platform-btn {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 6px 8px;
  border-radius: 6px;
  background-color: #06070F;
  background: linear-gradient(
    130deg,
    var(--grad-left-color) 0%,
    transparent 22%,
    transparent 78%,
    var(--grad-right-color) 100%
  );
  transition-property: background-color, --grad-left-color, --grad-right-color;
  transition-duration: 200ms;
  transition-timing-function: ease-in-out;
}
.authenticate-platform-btn.meta {
  --grad-left-color: rgba(0, 131, 255, 1);
  background-color: #06070F;
  --grad-right-color: rgba(0, 131, 255, 1);
}
.authenticate-platform-btn.meta:hover, .authenticate-platform-btn.meta.loading {
  --grad-left-color: rgba(0, 131, 255, 0.7);
  background-color: #212431;
  --grad-right-color: rgba(0, 131, 255, 0.7);
}
.authenticate-platform-btn.tiktok {
  --grad-left-color: rgba(0, 248, 240, 1);
  background-color: #06070F;
  --grad-right-color: rgba(255, 0, 79, 1);
}
.authenticate-platform-btn.tiktok:hover, .authenticate-platform-btn.tiktok.loading {
  --grad-left-color: rgba(0, 248, 240, 0.7);
  background-color: #212431;
  --grad-right-color: rgba(255, 0, 79, 0.7);
}
</style>